import { render, staticRenderFns } from "./modal-login.vue?vue&type=template&id=503e643c&"
import script from "./modal-login.vue?vue&type=script&lang=js&"
export * from "./modal-login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports